import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Menu', path: '/menu' },
    { name: 'Catering', path: '/catering' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_d5dd8d35-1c0f-4833-a146-f7afb485112b/artifacts/p068y61t_cc382898-3b14-4423-b334-18a7cbd7354a.png" 
              alt="Nanny's Logo" 
              className="h-16 w-16 object-contain"
            />
            <div className="hidden sm:block">
              <span className="text-2xl font-bold text-nanny-maroon">Nanny's</span>
              <p className="text-xs text-gray-600 -mt-1">From Our Kitchen To Yours</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  isActive(item.path)
                    ? 'text-nanny-maroon bg-nanny-cream'
                    : 'text-gray-700 hover:text-nanny-maroon hover:bg-nanny-cream/50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <a href="tel:731-267-9884" className="flex items-center space-x-2 text-nanny-maroon hover:text-nanny-dark transition-colors">
              <Phone className="h-5 w-5" />
              <span className="font-semibold">731-267-9884</span>
            </a>
            <Link to="/order">
              <Button className="bg-nanny-maroon hover:bg-nanny-dark text-white">
                Order Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? 'text-nanny-maroon bg-nanny-cream'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4 space-y-3">
                <a 
                  href="tel:731-267-9884" 
                  className="flex items-center justify-center space-x-2 px-4 py-3 text-nanny-maroon font-semibold"
                >
                  <Phone className="h-5 w-5" />
                  <span>731-267-9884</span>
                </a>
                <Link to="/order" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-nanny-maroon hover:bg-nanny-dark text-white">
                    Order Now
                  </Button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
